import React, { createContext, Dispatch, SetStateAction, useContext } from "react";
import { useStateSyncedWithQueryParam } from "@/dateRanges/UseInitialOverrideUnlessInQueryParamsOnFirstLoad";

export const electricityConsumptionUnits = {
  "kilowatt_hour": "kWh",
  "USD": "$"
}

export type ElectricityConsumptionUnit = keyof typeof electricityConsumptionUnits;

type ElectricityConsumptionUnitContextType = {
  electricityConsumptionUnit: ElectricityConsumptionUnit;
  setElectricityConsumptionUnit: Dispatch<SetStateAction<ElectricityConsumptionUnit>>;
};

const ElectricityConsumptionUnitContext = createContext<ElectricityConsumptionUnitContextType | undefined>(undefined);

const DEFAULT_ELECTRICITY_CONSUMPTION_UNIT = "kilowatt_hour"

export function ElectricityConsumptionUnitContextProvider({ children }: any) {

  const [electricityConsumptionUnit, setElectricityConsumptionUnit] = useStateSyncedWithQueryParam<ElectricityConsumptionUnit>(
    "electricityConsumptionUnit",
    DEFAULT_ELECTRICITY_CONSUMPTION_UNIT,
    (electricityConsumptionUnit) => electricityConsumptionUnit,
    (paramValue) => (
      paramValue && Object.keys(electricityConsumptionUnits).includes(paramValue)
        ? paramValue as ElectricityConsumptionUnit
        : DEFAULT_ELECTRICITY_CONSUMPTION_UNIT
    )
  );

  return (
    <ElectricityConsumptionUnitContext.Provider
      value={{
        electricityConsumptionUnit,
        setElectricityConsumptionUnit,
      }}
    >
      {children}
    </ElectricityConsumptionUnitContext.Provider>
  );
}


export function useElectricityConsumptionUnitContext() {
  const context = useContext(ElectricityConsumptionUnitContext);
  if (context === undefined) {
    throw new Error("Electricity Consumption Unit Context must be used within its Provider");
  }

  return context;
}
